import { CommCardWithSmartConnectId } from '../comm-card/comm-card-with-smart-connect-id.model';
import { ConnectedDevice } from '../connected-device.model';
import { IFirmware } from '../IFirmware';

export class ConnectedDeviceWithFirmwareInfo extends ConnectedDevice implements IFirmware
{
    public DeviceTypeName: string;
    public DeviceTypeUId: string;
    public FirmwareVersionId: number;
    public LatestFirmwareVersion: number;
    public FirmwareDescription: string;
    public CommCardWithSmartConnectId: CommCardWithSmartConnectId;

    constructor(json: object = null)
    {
        if (json)
        {
            super();

            Object.assign(this, json);

            if (json['CommCardWithSmartConnectId'])
            {
                this.CommCardWithSmartConnectId = new CommCardWithSmartConnectId(json['CommCardWithSmartConnectId']);
            }
        }
    }

    get DeviceId(): number
    {
        return this.Id;
    }

    public getName(): string
    {
        return this.Name;
    }
}
